import Base, {
  axios,
  setPromise,
  getEndpoint,
  omitId
} from './base'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint
} from './base'

const KEY = 'user.familyMember'
const PATH = '/customer/user/family-member'

const myServices = {}

export const create = myServices.create = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.create`, {}, `${PATH}`, options)
  const {data = {}} = await axios.post(endPoint, payload)
  return data
}
setPromise(`${KEY}.create`, create)

export const all = myServices.all = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.all`, payload, `${PATH}`, options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise(`${KEY}.all`, all)

export const get = myServices.get = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.get`, payload, `${PATH}/{id}`, options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise(`${KEY}.get`, get)

export const update = myServices.update = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.update`, payload, `${PATH}/{id}`, options)
  const {data = {}} = await axios.put(endPoint, omitId(payload))
  return data
}
setPromise(`${KEY}.update`, update)

export const updateOrCreate = myServices.updateOrCreate = async (payload, options = {}) => {
  if (payload.id) {
    return await update(payload, options)
  } else {
    return await create(payload, options)
  }
}
setPromise(`${KEY}.updateOrCreate`, updateOrCreate)

export const deleteMember = myServices.deleteMember = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.delete`, payload, `${PATH}/{id}`, options)
  const {data = {}} = await axios.delete(endPoint)
  return data
}
setPromise(`${KEY}.delete`, deleteMember)

export default {
  ...Base,
  ...myServices
}
